export function getAction(client,action,name){return params=>client[action.name||name]?.(params)??action(client,params)}